import { apiClient } from './client';

export async function getRolePermissionCleanupPlans(params = {}) {
  const { data } = await apiClient.get('/api/system/role-permission-cleanup-plans', { params });
  return data;
}

export async function getRolePermissionCleanupPlan(id) {
  const { data } = await apiClient.get(`/api/system/role-permission-cleanup-plans/${id}`);
  return data.data ?? data;
}

export async function getRolePermissionCleanupPlanItems(id) {
  const { data } = await apiClient.get(`/api/system/role-permission-cleanup-plans/${id}/items`);
  return data.data ?? data;
}

export async function previewRolePermissionCleanup(payload) {
  const { data } = await apiClient.post('/api/system/role-permission-cleanup-plans/preview', payload);
  return data.data ?? data;
}

export async function cancelRolePermissionCleanupPlan(id, payload = {}) {
  const { data } = await apiClient.post(`/api/system/role-permission-cleanup-plans/${id}/cancel`, payload);
  return data.data ?? data;
}

export async function markRolePermissionCleanupReady(id) {
  const { data } = await apiClient.post(`/api/system/role-permission-cleanup-plans/${id}/mark-ready`);
  return data.data ?? data;
}

export async function getTenantRolePermissionCleanupPlans(tenantId) {
  const { data } = await apiClient.get(`/api/system/tenants/${tenantId}/role-permission-cleanup-plans`);
  return data.data ?? data;
}

export async function getChangeRequestCleanupPlans(changeRequestId) {
  const { data } = await apiClient.get(`/api/system/subscription-change-requests/${changeRequestId}/role-permission-cleanup-plans`);
  return data.data ?? data;
}

export async function previewChangeRequestCleanup(changeRequestId) {
  const { data } = await apiClient.post(`/api/system/subscription-change-requests/${changeRequestId}/role-permission-cleanup-preview`);
  return data.data ?? data;
}

export async function getPortalRolePermissionCleanupSummary(customerId, tenantId) {
  const { data } = await apiClient.get(`/api/customer-portal/customers/${customerId}/tenants/${tenantId}/role-permission-cleanup-summary`);
  return data.data ?? data;
}
